import { RawSessionData } from '../sessions/types'
import { RawSessionEventData } from './types'

// "No session" sentinel; null enum/id fields are populated by real sessions.
// TODO: revisit cast — typing this honestly needs the shared type widened.
export const EMPTY_RAW_SESSION = {
  id: '',
  name: '',
  type: null,
  subType: null,
  mode: null,
  state: null,

  host: '',
  locationName: '',
  hostName: '',

  sport: null,
  pitchId: null,
  pitch: null,

  matchId: '',
  match: '',

  config: {},
  attributes: {},

  teamSessions: [],
  players: [],
  hardware: [],
  eventId: ''
} as unknown as RawSessionData

export const EMPTY_RAW_SESSION_EVENT_DATA = {
  id: '',
  createdAt: 0,
  updatedAt: 0,
  ignore: false,
  startTime: '',
  endTime: null,
  tags: {},
  properties: {},
  outcomes: [],
  parentId: '',
  hierarchy_level: 'Session',
  dataType: 'Session',
  data: EMPTY_RAW_SESSION,
  children: []
  // Sentinel blank; null fields need shared-type widening to type honestly.
  // TODO: revisit cast.
} as unknown as RawSessionEventData
